<template>
  <range
    :label="$t('edit.sidebar.height')"
    min="50"
    max="150"
    step="1"
    :value="value()"
    :change="onChange"
    :move="onMove"
  ></range>
</template>

<script>
import { mapGetters, mapActions } from 'vuex';
import Range from '../../../../general/Range.vue';

const defaultValue = 70;

export default {
  props: [
    'item',
    'general',
  ],
  components: {
    Range,
  },
  methods: {
    value() {
      const style = this.stepStyle(this.item);

      if (!style || !style.height) {
        return defaultValue;
      }

      return style.height.replace('px', '');
    },
    onChange(value) {
      if (this.general) {
        return this.quizUpdateStyle({
          item: this.item,
          rule: 'height',
          value: `${value}px`,
        });
      }

      return this.stepUpdateStyle({
        item: this.item,
        rule: 'height',
        value: `${value}px`,
      });
    },
    onMove(value) {
      if (this.general) {
        return this.quizPreviewStyleChange({
          item: this.item,
          rule: 'height',
          value: `${value}px`,
        });
      }

      return this.stepPreviewStyleChange({
        item: this.item,
        rule: 'height',
        value: `${value}px`,
      });
    },
    ...mapActions([
      'quizUpdateStyle',
      'quizPreviewStyleChange',
      'stepUpdateStyle',
      'stepPreviewStyleChange',
    ]),
  },
  computed: mapGetters({
    stepStyle: 'stepStyle',
  }),
};
</script>



/** WEBPACK FOOTER **
 ** Height.vue?704261e8
 **/